import React, { useEffect, useState } from 'react';
import useHomeLinkMode from "../../../hooks/useHomeLinkMode";
import useMobile from '../../../hooks/useMobile';
import MegaMenuMobile from '../mega-menu-mobile/mega-menu-mobile';
import Cookies from 'universal-cookie'
import LogoPeque from '../../../assets/images/logo-pequenin-desktop.png'
import { StaticImage } from 'gatsby-plugin-image'
import './nav-menu-mobile.scss'

const NavMenuMobile = ({ activeMenu, menuOptions, setActiveMenuMobile, chatRedirection, activeMenuMobile, setActiveShoppingModal }) => {

    const { homeLink } = useHomeLinkMode();
    const mobile = useMobile();
    const [logged, setLogged] = useState(false);
    const [activeMegaMenuMobile, setActiveMegaMenuMobile] = useState(null)

    useEffect(() => {
        let column = document.getElementById('column')

        if (activeMegaMenuMobile) {
            column.classList.add("__open-option")

        } else {
            column.classList.add("__close-option")
            column.classList.remove("__open-option")
            setTimeout(function () {
                column.classList.remove("__close-option")
            }, 300);
        }

    }, [activeMegaMenuMobile])

    useEffect(() => {
        if (localStorage.getItem('TOKEN_INFO')) {
            setLogged(true)
        }
    }, []);

    const logOut = () => {
        const cookies = new Cookies();
        cookies.remove('cartExpired', { path: '/' })
        localStorage.clear();
        location.reload();
    }

    const closeModal = () => {
        let content = document.getElementById('f-m-nav-menu-mobile__content')
        let close = document.getElementById('f-m-nav-menu-mobile__close')
        let logo = document.getElementById('logo')
        let column = document.getElementById('column')
        if (content) {
            close.classList.add("f-m-nav-menu-mobile__close-hidden")
            content.classList.add("f-m-nav-menu-mobile__content-hidden")
            logo.classList.add("f-m-nav-menu-mobile__logo-container-hidden")
            column.classList.add("__hidden")
            setTimeout(function () {
                close.classList.remove("f-m-nav-menu-mobile__close-hidden")
                content.classList.remove("f-m-nav-menu-mobile__content-hidden")
                logo.classList.remove("f-m-nav-menu-mobile__logo-container-hidden")
                column.classList.remove("__hidden")
                if (mobile) {
                    document.documentElement.style.overflow = 'scroll';
                    document.body.scroll = "yes";
                }
                setActiveMenuMobile(false);
            }, 200);
        } else {
            setActiveMenuMobile(false);
        }
    }

    return (
        <div className="f-m-nav-menu-mobile">
            <div className="f-m-nav-menu-mobile__background" onClick={closeModal}></div>
            <div className="f-m-nav-menu-mobile__content" id="f-m-nav-menu-mobile__content">
                <span className="icon icon-ico-x f-m-nav-menu-mobile__close" onClick={closeModal} id="f-m-nav-menu-mobile__close"></span>
                <div className="f-m-nav-menu-mobile__logo-container" id="logo">
                    <StaticImage
                        className="f-m-nav-menu-mobile__logo"
                        src='../../../assets/images/logo-pequenin-desktop.png'
                        alt='logo pequenin header'
                        loading="lazy"
                        placeholder="blurred"
                    />
                </div>
                <div className="f-m-nav-menu-mobile__col-wrapper" id="column">
                    <ul className="f-m-nav-menu-mobile__col" >
                        {menuOptions.map((item, index) => (
                            index != 0 &&
                            <li key={index}
                                className={"f-m-nav-menu-mobile__item " + (activeMenu === index ? "__active" : "")}
                                onClick={() => {
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackEvent',
                                        'eventCategory': 'ui :: home :: menu',
                                        'eventAction': 'click',
                                        'eventLabel': item.nombreDeLaOpcion
                                    });

                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'trackGA4',
                                        'event_type': 'user_interaction',
                                        'section': 'home',
                                        'action': 'click',
                                        'element': item.nombreDeLaOpcion,
                                        'flow': 'menu',
                                        'screen_name': 'home'
                                    });

                                    setActiveMegaMenuMobile(item)
                                }}
                            >
                                {item.opcionesSubmenu ?
                                    <div className="f-m-nav-item__menu">
                                        <a >{item.nombreDeLaOpcion}</a>
                                        <span className="icon-ico-right-arrow"></span>
                                    </div>
                                    : <a href={`${item.redireccionDeLaOpcion || ''}`}> {item.nombreDeLaOpcion}</a>
                                }
                            </li>

                        ))}

                        <a className="f-m-nav-menu-mobile-quick-access"
                            onClick={() => {
                                closeModal()
                                setActiveShoppingModal(true)
                            }}>
                            <span className="icon icon-ico-shopping-cart" />
                            <p>Compra</p>
                        </a>
                        {(process.env.LOCALE === "es-CO") &&
                            <a className="f-m-nav-menu-mobile-quick-access" href={homeLink + chatRedirection}>
                                <span className="icon icon-ico-chat" />
                                <p>Chat</p>
                            </a>
                        }
                        {logged &&
                            <a
                                className={"f-m-nav-menu-mobile-quick-access " + "__close-session"}
                                onClick={() => logOut()}
                            >
                                Cerrar Sesión
                            </a>}

                    </ul>
                </div>

                {activeMegaMenuMobile && <MegaMenuMobile menuOption={activeMegaMenuMobile} setActiveMegaMenuMobile={setActiveMegaMenuMobile} activeMegaMenuMobile={activeMegaMenuMobile} />}
            </div>
        </div>

    );
}

export default NavMenuMobile

